<template >
  <v-container class="text-center">
    <v-row>
      <v-col class="mb-4">
        <h1 class="text-lg-h2 text-xl-h2 text-md-h2 text-sm-h4 font-weight-bold mb-3 pageTitle">
          Track your packages
        </h1>
      </v-col>
    </v-row>

    <v-row class="searchField" align="end">
      <v-text-field
          v-model="trackingNumber"
          class="searchFieldText"
          :counter="15"
          label="Tracking number"
          required
          color="#F57F17"
          v-on:keyup.enter="pushToResultRoute(trackingNumber)"
      >
      </v-text-field>
    </v-row>
    <v-row class="searchField" align="end">
      <v-btn
          class="mr-4 searchButton"
          color="#ffdb58"
          @click="pushToResultRoute(trackingNumber)"
      >
        search
      </v-btn>
    </v-row>
    <v-row v-if="showProgressBar"
           align-content="center"
           justify="center"
    >
      <v-progress-linear
          indeterminate
          color="#F57F17"
      ></v-progress-linear>
    </v-row>

    <v-row v-if=hasFetchedData>
      <Result
          :search-result="searchResult"
          :error="error"
          :error-text="errorText"
          :token="token"
      />
    </v-row>


  </v-container>
</template>

<script>
import Result from './Result';
import axios from 'axios';

export default {
  name: 'Search',

  components: {
    Result
  },

  props: ['resetPage'],

  data: () => ({
    hasFetchedData: false,
    showProgressBar: false,
    trackingNumber: '',
    token: null,
    error: false,
    errorText: "There is no order with this tracking number.",
    searchResult: {},
  }),

  /**
   * if user gets routed to result:CASE_ID, then fetch the data directly and show the results
   * Created gets called here because the router-view is set to route.fullPath
   **/
  created() {
    //get tracking number from url
    let param = this.$route.params.trackingNumber
    //if tracking number is in url null fetch data and show result
    if (param != null) {
      //fetch data and display result
      this.fetchDelivery(param)
    }
  },

  methods: {
    /**
     * when user searches for tracking number it pushes app to corresponding route
     * Route gets only pushed if the search field is not empty and new route != current route
     * @param value (trackingNumber / Case_ID)
     **/
    pushToResultRoute(value){
      //if user has no input then return directly and do nothing
      if(value.length === 0){        return      }

      //push to result route if not already in end route
      if (this.$router.currentRoute.fullPath !== ("/result/" + String(value))) {
        this.$router.push('/result/' + String(value))
      }
    },
    /**
     * fetches data based on the written CASE_ID
     * @param value (CASE_ID)
     **/
    async fetchDelivery(value) {

      //if input in invalid set error to true and return
      if(!this.userInputIsValid(value)){
        this.errorText = "There is no order with this tracking number."
        this.error = true
        //show result component
        this.hasFetchedData = true
        return
      }

      //disable result view
      this.hasFetchedData = false;
      //show progressbar
      this.showProgressBar = true;

      //get bearer Token
      this.token = await this.getBearerToken()

      //add bearer token to header
      let apiConfig = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      }
      //get tracking information by fetching
      await axios.get(process.env.VUE_APP_API_TRACKINGINFO + "?CaseId=" + value, apiConfig)
          .then((response) => {
            this.searchResult = response.data
          })
          .catch((error) => {
            console.log("error", error.code)
            this.error = true
            this.showProgressBar = false
            this.hasFetchedData = true
          })

      //if result is resp. no transports have been found show error
      if(this.searchResult.trackingStates.length > 0){
        this.error = false
        //calculate State number based on Status_Typ
        this.searchResult.trackingStates = this.addStateNumberToStatus(this.searchResult.trackingStates)
      }else{
        //no status for order
        this.error = true
      }

      //show result component
      this.hasFetchedData = true
      //disable progressBar
      this.showProgressBar = false
    },

    /**
     * authenticate with api and return jwt token
     * @returns {Promise<void>}
     */
    async getBearerToken(){
      let bodyFormData = new FormData();
      bodyFormData.append('grant_type', 'password');
      bodyFormData.append('username', process.env.VUE_APP_USER);
      bodyFormData.append('password', process.env.VUE_APP_PW);
      let token = null;

      await axios({
        method: "post",
        url: process.env.VUE_APP_API_AUTH,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
          .then(function (response) {
            //handle success
            token = response.data.access_token
          })
          .catch(() => {
            //handle error
            this.error = true
            return null;
          });
      return token
    },

    /**
     * Add statusNummer as a attribute to status array of response
     * statusNummer needed for stepper creation and sorting
     * @param status [{type: STRING, Datum: STRING}]
     * @return [{type: STRING, Datum: STRING, statusNummer: INT}]
     */
    addStateNumberToStatus(status){
      status.forEach(function(item){
        switch(item["type"]){
          case "LOADED":
                item["statusNummer"] = 1;
                break;
              case "IN ALTISHOFEN":
                item["statusNummer"] = 2;
                break;
              case "FORWARDED":
                item["statusNummer"] = 3;
                break;
              case "DELIVERED":
                item["statusNummer"] = 4;
                break;
        }
      })
      return status
    },

    /**
     * Validate user input
     * Only returns true if the input has either 3 chars with 2 digits following or 10 digits in total
     * @param value
     */
    userInputIsValid(value) {
      /*if(value.length !== 10 && value.length !== 5){
      return false
    }else if(value.length === 10){
      return value.match(/^[0-9]+$/) != null; //true if only digits and 10 length
      }else if(value.length === 5){
        return value.match(/^[a-zA-Z][a-zA-Z][a-zA-Z][0-9]+$/) != null //true if starts with 3 strings and ends with 2 digits
      }
    }*/
      if(value.length < 1){
      return false
      } else{
        return true
      }
    }
  }
}
</script>

<style>

</style>
